import "./badge.scss";

interface IBadgeProps {
  children?: React.ReactNode;
}

const Badge = (props: IBadgeProps) => {
  const { children } = props;
  return (
    <div className="m-badge">
      {children}
    </div>
  );
};

export default Badge;
